import { render } from "./MyLocations.vue?vue&type=template&id=4353e927&scoped=true"
import script from "./MyLocations.vue?vue&type=script&lang=js"
export * from "./MyLocations.vue?vue&type=script&lang=js"

import "./MyLocations.vue?vue&type=style&index=0&id=4353e927&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4353e927"]])

export default __exports__